import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BlockUIModule } from 'ng-block-ui';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BplogsComponent } from './components/search/bplogs/bplogs.component';
import { CompanylogsComponent } from './components/search/companylogs/companylogs.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SideMenuComponent } from './components/shared/side-menu/side-menu.component';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { FooterComponent } from './components/shared/footer/footer.component';
import { CompanyComponent } from './components/config/company/company.component';
import { AlertComponent } from './components/config/alert/alert.component';
import { AssignAlertToCompanyComponent } from './components/config/assign/assign-alert-to-company/assign-alert-to-company.component';
import { LoginComponent } from './components/shared/login/login.component';
import { ManagerComponent } from './components/config/manager/manager.component';
import { ManagerByCompanyComponent } from './components/config/manager-by-company/manager-by-company.component';
import { SupplierlogsComponent } from './components/search/supplierlogs/supplierlogs.component';
import { SidebarModule } from 'ng-sidebar';
import { HeaderComponent } from './components/shared/header/header.component';

@NgModule({
  declarations: [
    AppComponent,    
    BplogsComponent, CompanylogsComponent, SideMenuComponent, FooterComponent, CompanyComponent, 
    AlertComponent, AssignAlertToCompanyComponent, LoginComponent, ManagerComponent, ManagerByCompanyComponent, SupplierlogsComponent, HeaderComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BlockUIModule.forRoot(),
    NgbModule,
    DeviceDetectorModule.forRoot(),
    SidebarModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
